import main from './img/main.png';
import pass from './img/pass.png';
import keyboard from './img/keyboard.png';
import money from './img/money.png';
import card from './img/card.png';
import bill from './img/bill.png';
import trade from './img/trade.png';

export const images = [
    main, pass, keyboard, money, card, bill, trade
];